<template>
  <div class="custom-control custom-switch">
    <input :id="componentId" v-model="localFlag" :disabled="disabled" type="checkbox" class="custom-control-input" />
    <label class="custom-control-label" :for="componentId"></label>
  </div>
</template>

<script>
import 'bootstrap/js/dist/index'

const modelEventName = "change-switch-flag"

export default {
  model: {
    prop: 'flag',
    event: modelEventName,
  },
  props: {
    flag: {
      type: Boolean,
      default: false,
    },
    componentId: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    localFlag: {
      get() {
        return this.flag
      },
      set(v) {
        this.$emit(modelEventName,v)
        this.$emit('change', v)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'bootstrap/scss/bootstrap.scss';

.custom-control-label {
  &:before {
    background-color: #8a8bc0 !important;
  }

  &:after {
    background-color: #fff !important;
  }
}

.custom-control-input:checked + .custom-control-label {
  &:before {
    background-color: #001a70 !important;
    border-color: #001a70 !important;
  }
}

.custom-control-input:disabled + .custom-control-label {
  &:before {
    background-color: #e4e7ea !important;
    border-color: #e4e7ea !important;
  }
}
</style>
